import { STEPS_INTL_2LW } from 'cohorts/intl_2lw/constants/steps'
import { STEPS_INTL_2LW_INTRO_CERTIFICATE } from 'cohorts/intl_2lw/constants/steps-intro-certificate'
import { PageId } from 'constants/pages'
import {
  Cohort,
  FirebaseRemoteConfigTestGroup,
  GrowthbookKey,
} from 'root-constants'
import type { TStep } from 'src/types'
import { useZustandStore } from 'zustandGlobalStore'

// Computes the abtest_web_127_first_screen group from GrowthBook. Only meant
// to feed the one-time snapshot taken by useIsFlowVariantResolved: reads the
// same value useFeatureValue returns, so the snapshot and the components
// that branch on the live hook never disagree.
export const resolveFirstScreenVariantIntl2Lw = (): string => {
  const { growthbook, lead, initialCohort } = useZustandStore.getState()
  const cohort = lead?.cohort || initialCohort

  if (cohort !== Cohort.INTL_2LW) {
    return FirebaseRemoteConfigTestGroup.ABTEST_WEB_127_A_DEFAULT
  }

  const abTestFirstScreenValue = growthbook?.getFeatureValue(
    GrowthbookKey.ABTEST_WEB_127_FIRST_SCREEN,
    FirebaseRemoteConfigTestGroup.ABTEST_WEB_127_A_DEFAULT,
  ) as string | undefined

  return (
    abTestFirstScreenValue ||
    FirebaseRemoteConfigTestGroup.ABTEST_WEB_127_A_DEFAULT
  )
}

// Synchronous, non-React resolver of the abtest_web_127_first_screen group.
// Needed outside of React components/hooks (dynamic-components-map,
// getCohortSteps). Reads the snapshot resolved before the flow rendered, so
// the flow shape cannot flip within a session.
export const getFirstScreenVariantIntl2Lw = (): string => {
  const { firstScreenVariantIntl2Lw } = useZustandStore.getState()

  return firstScreenVariantIntl2Lw ?? resolveFirstScreenVariantIntl2Lw()
}

const isIntroCertificateVariant = (): boolean =>
  getFirstScreenVariantIntl2Lw() ===
  FirebaseRemoteConfigTestGroup.ABTEST_WEB_127_C_IQ_CERTIFICATE

export const getStepsIntl2Lw = (): TStep[] =>
  isIntroCertificateVariant()
    ? STEPS_INTL_2LW_INTRO_CERTIFICATE
    : STEPS_INTL_2LW

// Page the intl_2lw flow actually starts at, matching the initial step of
// getStepsIntl2Lw. Used as the route redirect target so the router never
// sends the user to a page the machine is not on.
export const getFirstRoutePageIdIntl2Lw = (): PageId =>
  getStepsIntl2Lw()[0].pageId
